import { Permission } from '@frontend/authorization';
import { ClassType } from '@frontend/common';
import React from 'react';
import { IconType } from 'react-icons';

import { Spinner } from '../../spinner.component';
import useHorizontalButtonGroup from './horizontal-button-group.controller';

const ID = 'horizontal-button-group';
export interface Button {
    text: React.ReactNode;
    disabled?: boolean;
    onClick?: (e?: React.MouseEvent) => void;
    icon?: IconType;
    type?: ClassType;
    isLoading?: boolean;
    hide?: boolean;
    id?: string;
    requiredPermissions?: Permission[];
}

export interface HorizontalButtonGroupProps {
    buttons: Button[];
    direction: 'left' | 'right';
    noFlex?: boolean;
}

export const HorizontalButtonGroup = (props: HorizontalButtonGroupProps) => {
    const viewProps = useHorizontalButtonGroup(props);

    return (
        <div
            id={ID}
            style={viewProps.style}>
            {viewProps.buttons.map((button, i) => {
                const marginStyle = {
                    marginRight: props.direction === 'right' ? '10px' : '0',
                    marginLeft: props.direction === 'left' ? '10px' : '0'
                };

                return (
                    <button
                        id={button.id}
                        onClick={button.onClick}
                        className={'my-0 btn ' + (button.type ? 'btn-' + button.type : 'btn-secondary')}
                        key={i}
                        style={{ ...marginStyle }}
                        disabled={button.disabled}>
                        <div className='d-flex flex-row align-items-center'>
                            {button.isLoading ? (
                                <Spinner />
                            ) : (
                                <>
                                    {button.icon && <button.icon />}
                                    <span className='ps-2'>{button.text}</span>
                                </>
                            )}
                        </div>
                    </button>
                );
            })}
        </div>
    );
};
